import axios from "axios";
import authHeader from "./auth-header";

const API_URL = process.env.REACT_APP_API_URL;

const user = JSON.parse(localStorage.getItem('user'));

const createNewDemo = async (data) => {
  const response = await axios.post(API_URL + "api/demo", { ...data }, { headers: authHeader() });
  return response.data;
};

const getDemo = async () => {
  const response = await axios.get(API_URL + `api/demo/dealer/${user.dealer_id}`, { headers: authHeader() });
  return response.data;
};

const getDemoById = async (id) => {
  const response = await axios.get(API_URL + `api/demo/id/${id}`, { headers: authHeader() });
  return response.data;
};

const updateDemo = async (e_id, formData) => {
  const response = await axios.put(API_URL + `api/demo/id/${e_id}`, {...formData}, { headers: authHeader() });
  return response.data;
};

const deleteDemo = async (e_id) => {
  const response = await axios.delete(API_URL + `api/demo/id/${e_id}`, { headers: authHeader() });
  return response.data;
};

const demoService = {
  createNewDemo,
  getDemo,
  updateDemo,
  deleteDemo,
  getDemoById
};

export default demoService